import React, {Component} from 'react';
import {connect} from 'react-redux';
import PageTemplate from '../components/PageTemplate/PageTemplate';
import BasicText from '../components/BasicText/BasicText';
import ActionButton from '../components/ActionButton/ActionButton';
import TriggerSettingsQueryContainer from './TriggerSettingsQueryContainer';
import CompleteModalContainer from './CompleteModalContainer';
import {getApolloClient} from '../../../lib/graphQL/apolloClient';
import {DELETE_NEST_TRIGGER_SETTINGS} from '../../../lib/graphQL/nest/queries';
import {NestActions} from '../../../store/actionCreators';
import {withRouter} from 'react-router-dom';
import Store from '../../../store';
import {getOS} from '../../../lib/functions';

class SettingViewContainer extends Component {
  state = {
    shouldShowCompleteModal: false
  }

  handleDisconnectDevice = () => {
    const nestState = Store.getState() && Store.getState().nest;

    if (nestState != null) {
      const initialTriggerEntities = nestState.toJS().initialTriggerEntities;
      const deleteTriggerIds = Object.keys(initialTriggerEntities).reduce((accumulator, key) => {
        return (initialTriggerEntities[key].triggerUuid != null) ?
               [...accumulator, initialTriggerEntities[key].triggerUuid] :
               accumulator;
      }, []);

      if (deleteTriggerIds.length > 0) {
        NestActions.setLoading();

        getApolloClient().mutate({
          mutation: DELETE_NEST_TRIGGER_SETTINGS,
          variables: {
            triggerIds: deleteTriggerIds
          }
        })
          .then( () => {
            NestActions.unsetLoading();
            NestActions.convertToInitialValue(true);
            NestActions.hideCompleteModal({isClosed: false, text: 'Done!'});
          })
          .catch(error => {
            NestActions.unsetLoading();
            alert('Failed to disconnect Nest.\nPlease try again later.');
          });
      } else {
        NestActions.setLoading();
        setTimeout(() => {
          NestActions.unsetLoading();
          NestActions.convertToInitialValue(true);
          NestActions.hideCompleteModal({isClosed: false, text: 'Done!'});
        }, 500);
      }
    }
  };

  openPlayStore = () => {
    window.android && window.android.navigateToPlayStore();
  };

  openAppStore = () => {
    window.location.replace('nestmobile://');
  };

  openNestApp = () => {
    const {openPlayStore, openAppStore} = this;
    // Won't work on android if os of core store is used
    const OS = getOS(window.navigator.userAgent);

    if (OS === 'Android') {
      openPlayStore();
    } else if (OS === 'iOS') {
      openAppStore();
    }
  };

  render() {
    const {contents, accessToken, deviceUuid, targetId} = this.props;
    const {handleDisconnectDevice} = this;
    const {shouldShowCompleteModal} = this.state;

    if (!accessToken) {
      return null;
    }

    const deviceType = deviceUuid.split('_')[0];

    return (
      <PageTemplate>
        <CompleteModalContainer isClosed={!shouldShowCompleteModal}/>
        <BasicText text={contents.settingGuideText1[deviceType]}/>
        <TriggerSettingsQueryContainer deviceUuid={deviceUuid} targetId={targetId}/>
        <BasicText text={contents.settingGuideText2}/>
        <ActionButton text={contents.moveNestAppBtnText} onClick={this.openNestApp}/>
        <ActionButton negative={true}
                      text={contents.disconnectNestBtnText}
                      onClick={handleDisconnectDevice}/>
      </PageTemplate>
    );
  }
}

export default withRouter(connect(
  ({nest}) => ({
    accessToken: nest.awairQueryParams.accessToken,
    deviceUuid: nest.awairQueryParams.deviceUuid,
    targetId: nest.targetId
  }),
  () => ({})
)(SettingViewContainer));


// WEBPACK FOOTER //
// ./src/app/nest/containers/SettingViewContainer.js